import React from 'react';
import './HeaderBanner.css';

/**
 * HeaderBanner
 * A unified, reusable header banner with a gradient background and
 * an underlined title. Accepts optional subtitle and right-side content.
 */
export default function HeaderBanner({
  title,
  subtitle,
  children,
  align = 'center',
}) {
  return (
    <header className={`hb-root align-${align}`}>
      <div className='hb-inner'>
        <div className='hb-texts'>
          <h1 className='hb-title'>{title}</h1>
          <div className='hb-underline' aria-hidden />
          {subtitle ? <div className='hb-subtitle'>{subtitle}</div> : null}
        </div>
        {children ? <div className='hb-right'>{children}</div> : null}
      </div>
    </header>
  );
}
